export default __webpack_public_path__ + "static/media/05.c263b99d.webp";